import {
  LOCATION_SENSOR_HISTORY_REQUEST,
  LOCATION_SENSOR_HISTORY_SUCCESS,
  LOCATION_SENSOR_HISTORY_ERROR
} from '../utils/app_constants';

const LOCATION_SENSOR_HISTORY_INITIAL_STATE = {};

export const locationSensorHistoryReducer = (
  state = LOCATION_SENSOR_HISTORY_INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case LOCATION_SENSOR_HISTORY_REQUEST:
      return {
        ...state,
        [action.deviceId]: {
          payload: {},
          isLoading: true,
          hasError: false
        }
      };
    case LOCATION_SENSOR_HISTORY_SUCCESS:
      return {
        ...state,
        [action.deviceId]: {
          payload: { ...action.payload },
          isLoading: false,
          hasError: false
        }
      };
    case LOCATION_SENSOR_HISTORY_ERROR:
      return {
        ...state,
        [action.deviceId]: {
          isLoading: false,
          hasError: true,
          payload: action.payload
        }
      };
    default:
      return state;
  }
};
